<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
                  <div class="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1 filter-box">

                    <div class="row-flex">
                      <fieldset class="form-group">
                        <ng-select
                        [items]="status_list"
                        bindLabel="displayname"
                        bindValue="_id"
                        placeholder="Select Status"
                        [(ngModel)]="selected_status"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="getStatusId($event)"
                        >
                        </ng-select>
                      </fieldset>
                    </div>

                    <div class="row-flex">
                      <fieldset class="form-group">
                        <ng-select
                            [items]="opening_list"
                            bindLabel="title"
                            bindValue="_id"
                            placeholder="Select Opening"
                            [(ngModel)]="selected_opening"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="getOpeningId($event)"
                        >
                        </ng-select>
                      </fieldset>
                    </div>
                    <!-- <div class="row-flex">
                      <fieldset class="form-group">
                        <ng-select
                              [items]="appliedSort_list"
                              bindLabel="name"
                              placeholder="Select one"
                              [(ngModel)]="selected_appliedSort"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getAppliedSortId($event)"
                          >
                        </ng-select>
                        </fieldset>
                    </div> -->
                  </div>
                  
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" #name [(ngModel)]="searchVal" (keypress)="filterCandidate(searchVal)"/>
                        <button class="btn search-btn glow position-absolute">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          routerLink="/candidates-management/add" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                      [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                      [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
                  <div class="col" *ngIf="guideline_data">
                    <button class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Candidates Guideline</button>
                  </div>
                </div>
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
                (page)="pageChangeData($event)">
                <ngx-datatable-column name="Name" prop="name">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                       
                      <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                        <div class="avatar-content">{{ row?.name  | shortName }}</div>
                      </div>
                      <div class="cell-line-height cursor-pointer" (click)="openModal(detailsModal,row)">
                        <p class="font-medium-1 line-height-1 mb-0" placement="right" ngbTooltip="Click to see notes and admin notes">
                          {{row?.name }}
                        </p>
                        <span *ngIf="row?.jobopening?.title" class="badge badge-pill bg-light-info my-2"
                        placement="right" ngbTooltip="job opening">
                          {{row?.jobopening?.title}}
                        </span>
                        <span *ngIf="row?.tagging?.displayname" class="badge badge-pill bg-light-primary my-2"
                        placement="right" ngbTooltip="tagging">
                          {{row?.tagging?.displayname}}
                        </span>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column> 
                <!-- <ngx-datatable-column name="Title" prop="title" *ngIf="isdropDownFilter">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <p class="font-medium-1 line-height-1 mb-0">{{row?.name}}</p>
                  </ng-template>
                </ngx-datatable-column> -->
                <ngx-datatable-column name="Email" prop="email" *ngIf="isdropDownFilter">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="email-box">{{row?.email}}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Phone" prop="phone" *ngIf="isdropDownFilter">
                </ngx-datatable-column>
                <ngx-datatable-column name="Email" prop="email" *ngIf="!isdropDownFilter">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="email-box">{{row?.email}}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Phone" prop="phone" *ngIf="!isdropDownFilter">
                </ngx-datatable-column>
                <!-- <ngx-datatable-column name="Job Opening" prop="jobopening" *ngIf="!isdropDownFilter">
                </ngx-datatable-column> -->
                
                <ngx-datatable-column name="Address" prop="address" *ngIf="isdropDownFilter">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{row?.address}}
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column name="Applied For" prop="applied_for" *ngIf="isdropDownFilter">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <div class="d-flex flex-wrap">
                      <div *ngFor="let user of row?.applied_for; let i = index;">
                        <span *ngIf="i < 3">{{user?.name}}{{i < 2 && ' , ' }}</span>
                      </div>
                    </div>
                    
                    <span class="badge badge-pill ml-1" *ngIf="row?.applied_for?.length > 3">+ {{row?.applied_for?.length - 3}} more</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Short Listed" prop="sort_listed"  *ngIf="isdropDownFilter">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <div class="d-flex flex-wrap">
                      <div *ngFor="let user of row?.sort_listed; let i = index;">
                        <span *ngIf="i < 3">{{user?.name}}{{i < 2 && ', '}}</span>
                      </div>
                    </div>
                    <span class="badge badge-pill ml-1" *ngIf="row?.sort_listed?.length > 3">+ {{row?.sort_listed?.length - 3}} more</span>
                  </ng-template>
                </ngx-datatable-column> -->
  
                <ngx-datatable-column name="Actions" 
                  *ngIf="user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i mat-button="mat-button" [matMenuTriggerFor]="menu" class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                    <mat-menu #menu="matMenu">
                      <div  class="menu-box">
                        <button class="btn bg-light-primary my-1" (click)="editCandidate(row)">Edit</button>
                        <button *ngIf="user_role.roles =='admin'" class="btn bg-light-danger my-1" (click)="ConfirmColor(row._id)">Delete</button>
                        <button *ngFor="let item of client_tags_list" class="btn bg-light-secondary my-1" (click)="updateTags(row,item._id)">
                          {{item?.displayname}}
                        </button>
                      </div>
                    </mat-menu>


                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>                                                                          
  </div>

<!--  -->

<div>
  <ng-template #detailsModal let-modal>
      <div class="modal-header">
          <h4 class="modal-title">{{candidate_model?.name}}</h4>
          <button type="button" class="close" (click)="modal.dismiss()">
              <span>&times;</span>
          </button>
      </div>
      <div class="modal-body">
        <div class="d-flex justify-content-between">
          <div *ngIf="!isEditor">
            
            <div class="d-flex" *ngIf="candidate_model?.notes">
              <strong id="key-text">Notes :</strong> <p class="ml-1" [innerHtml]="candidate_model?.notes"></p> 
            </div>
            <div class="d-flex" *ngIf="candidate_model?.notes">
              <strong id="key-text">Admin Notes :</strong> <p class="ml-1" [innerHtml]="candidate_model?.admin_notes"></p> 
            </div>
          </div>
          <div>
            <div *ngIf="candidate_model?.notes && isEditor">
              <label>Notes</label>
              <quill-editor (onContentChanged)="inlineAddupdateBody(candidate_model.notes,'notes')" [(ngModel)]="candidate_model.notes"
                [ngModelOptions]="{standalone: true}">
              </quill-editor>
              <!-- <textarea name="notes"placeholder="Enter notes" id="notes" cols="30" rows="3" class="form-control" [(ngModel)]="row_data.notes" [ngModelOptions]="{standalone: true}"></textarea> -->
            </div>
            <div *ngIf="candidate_model?.admin_notes && isEditor">
              <label>Admin Notes</label>
              <quill-editor (onContentChanged)="inlineAddupdateBody(candidate_model.admin_notes,'admin_notes')" [(ngModel)]="candidate_model.admin_notes"
                [ngModelOptions]="{standalone: true}">
              </quill-editor>
              <!-- <textarea name="admin_notes"placeholder="Enter admin notes" id="admin_notes" cols="30" rows="3" class="form-control" [(ngModel)]="row_data.admin_notes" [ngModelOptions]="{standalone: true}"></textarea> -->
            </div>
          </div>
          <div *ngIf="this.user_role.roles == 'admin'|| user_type == 'HR' || user_type == 'Managment'">
            <span class="ml-2"> <i (click)="isEditor =!isEditor" class="ft-edit text-primary cursor-pointer"></i> </span>
          </div>
        </div>
      </div>
      <div class="modal-footer" *ngIf="isEditor">
          <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="submit()">Submit</button>

      </div>
  </ng-template>
</div>


